
import React, { useState } from 'react';
import { UserRole } from '../types.ts';
import { MENU_ITEMS } from '../constants.tsx';
import { LogOut, Activity, ChevronLeft, ChevronRight } from 'lucide-react';

interface SidebarProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  userRole: UserRole;
  onLogout: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ activeTab, setActiveTab, userRole, onLogout }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <aside
      className={`bg-[#1e2329] border-r border-[#474d57] hidden md:flex flex-col transition-all duration-300 ease-in-out relative ${isCollapsed ? 'w-20' : 'w-72'
        }`}
    >
      {/* Botão para Minimizar/Expandir */}
      <button
        onClick={() => setIsCollapsed(!isCollapsed)}
        className="absolute -right-3 top-20 bg-[#00ff66] text-[#0b0e11] rounded-full p-1 shadow-lg hover:scale-110 transition-transform z-50 border-2 border-[#1e2329]"
      >
        {isCollapsed ? <ChevronRight size={16} strokeWidth={3} /> : <ChevronLeft size={16} strokeWidth={3} />}
      </button>

      <div className={`p-6 flex items-center gap-3 overflow-hidden ${isCollapsed ? 'justify-center' : ''}`}>
        <div className="bg-[#00ff66] p-2 rounded-xl rotate-3 shadow-[0_0_20px_rgba(0,255,102,0.3)] shrink-0">
          <Activity className="text-[#0b0e11]" size={24} strokeWidth={2.5} />
        </div>
        {!isCollapsed && (
          <div className="flex flex-col">
            <h1 className="text-xl font-black tracking-tighter uppercase text-white whitespace-nowrap flex items-center">
              Fifa<span className="text-[#00ff66]">Lytics</span>
              <span className="bg-[#fbbf24]/10 text-[#fbbf24] text-[9px] font-black px-1.5 py-0.5 rounded border border-[#fbbf24]/20 tracking-widest leading-none ml-2">
                V.1.1.b
              </span>
            </h1>
          </div>
        )}
      </div>

      <nav className="flex-1 px-3 space-y-1 mt-4">
        {MENU_ITEMS.map((item) => {
          const isAdminContent = item.adminOnly;
          const hasAdminAccess = userRole === UserRole.ADMIN || userRole === UserRole.SUPER_ADMIN;

          if (isAdminContent && !hasAdminAccess) return null;

          const isActive = activeTab === item.id;
          return (
            <button
              key={item.id}
              onClick={() => setActiveTab(item.id)}
              title={isCollapsed ? item.label : ''}
              className={`w-full flex items-center gap-3 px-4 py-4 rounded-lg transition-all duration-200 group ${isCollapsed ? 'justify-center' : ''
                } ${isActive
                  ? 'bg-[#2b3139] text-[#00ff66] border-l-4 border-[#00ff66]'
                  : 'text-white hover:bg-[#2b3139] hover:text-[#00ff66]'
                }`}
            >
              <div className={`${isActive ? 'text-[#00ff66]' : 'group-hover:scale-110 transition-transform'}`}>
                {item.icon}
              </div>
              {!isCollapsed && (
                <span className="font-bold uppercase tracking-widest text-[13px] whitespace-nowrap">
                  {item.label}
                </span>
              )}
            </button>
          );
        })}
      </nav>

      <div className="p-4 border-t border-[#474d57]">
        <button
          onClick={onLogout}
          title={isCollapsed ? 'Sair' : ''}
          className={`w-full flex items-center gap-3 px-4 py-4 text-white hover:text-[#f6465d] transition-colors rounded-lg group ${isCollapsed ? 'justify-center' : ''
            }`}
        >
          <LogOut size={20} className="group-hover:translate-x-1 transition-transform shrink-0" />
          {!isCollapsed && (
            <span className="font-bold uppercase tracking-widest text-[13px] whitespace-nowrap">Sair</span>
          )}
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
